let arr=[
    {name:'90天',value:'90天'},
    {name:'60天',value:'60天'},
    {name:'30天',value:'30天'}
]
export default arr

